import { CUSTOM_BET_PATH } from 'constants/appConfig';
import { makeRequest } from 'utils/REST';

const request = (requestType, url, data) => {
    return makeRequest(requestType, url, data)
        .then((response) => {
            return response.json();
        })
        .then((data) => {
            return data;
        });
};

const post = (method, data) => {
    return request('post', CUSTOM_BET_PATH + method, data);
};

const get = (method, data) => {
    return request('get', CUSTOM_BET_PATH + method, data);
};

export default {
    getCustomBetOffer: (marketId) => get(`available/${marketId}`),
    addCustomBetMarket: (gameId, betId, isLive) =>
        post(`add`, {
            gameId,
            betId,
            live: isLive,
        }),
    getSlip: () => get(`slip`),
    clearMarkets: () => post(`clear`),
    removeMarket: (gameId, betNr) => post(`del/${gameId}/${betNr}`),
    placeBet: (odds, stake, freeBet) =>
        post(`buy`, {
            odds,
            stake,
            freeBet,
        }),
    getCustomBetRecommendation: (id) =>
        get(`customBuilder${id ? `?eventId=${id}` : ''}`),
    placeCustomBetRecommendation: (uofEventId, uofExternalIds) =>
        post(`addExternal`, {
            uofEventId,
            uofExternalIds,
        }),
};
/*{
    "uofEventId": "sr:match:49369091",
    "uofExternalIds": "uof:3/sr:sport:1/1/1;uof:3/sr:sport:1/18/12?total=3.5;"
}*/
